<template>
  <BlocoFormularioCadastro
    :tem-voltar="false"
    :pode-salvar="carregando || !pagamentoFinalizado"
    @salvar="submeterPagamento()"
  >
    <template v-if="pagamentoSubmetido" #toolbar>
      <button
        data-test-id="button-finalizarpagamento-1"
        type="button"
        class="btn btn-info"
        @click="finalizarPagamento()"
      >
        Finalizar
      </button>
    </template>
    <template #form>
      <div>
        <!-- Seleção de Mês -->
        <div class="panel panel-primary">
          <div class="panel-heading"> Submissão de Guias para Pagamento </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                  <label>Período</label>
                  <select
                    v-model="filtro.mesAno"
                    data-test-id="select-filtro-mesano"
                    class="form-control"
                    @change="aoAlterarPeriodo"
                  >
                    <option disabled value="">Selecione o período</option>
                    <option
                      v-for="opcao in opcoesMesAno"
                      :key="opcao.valor"
                      :value="opcao.valor"
                    >
                      {{ opcao.texto }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                  <label>Status</label>
                  <input
                    data-test-id="input-auto-2"
                    :value="status"
                    disabled
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!pagamentoFinalizado" class="panel panel-primary">
          <div class="panel-heading"> Adicione uma Guia </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <BuscarSelecionarGuia
                  :key="buscarGuiaKey"
                  ref="buscarGuiaComponent"
                  :minimo="1"
                  @selecionadoGuia="aoSelecionarGuia"
                />
              </div>
              <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                  <label>Sessões</label>
                  <input
                    v-model.number="sessoesSelecionadas"
                    data-test-id="input-auto-3"
                    type="number"
                    class="form-control"
                    :min="1"
                    :disabled="!guiaSelecionada"
                    placeholder="Selecione a quantidade de sessões"
                  />
                </div>
              </div>
              <div class="col-xs-12 col-sm-2">
                <div class="form-group">
                  <label class="invisible">Ação</label>
                  <button
                    data-test-id="button-adicionarguiaselecionada-4"
                    :disabled="!guiaSelecionada"
                    type="button"
                    class="btn btn-primary btn-block"
                    @click="adicionarGuiaSelecionada"
                  >
                    Adicionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel panel-primary">
          <div class="panel-heading">
            Guias Selecionadas ({{ guiasSelecionadas.length }})
          </div>
          <div v-if="guiasSelecionadas.length === 0" class="panel-body">
            <div class="well">
              <p>Nenhuma guia selecionada.</p>
            </div>
          </div>
          <div v-else class="panel-body">
            <div class="row">
              <div
                v-for="(guia, index) in guiasSelecionadas"
                :key="guia.numero + index"
                class="col-xs-12 col-sm-6 col-md-4"
              >
                <div class="panel panel-default">
                  <div class="panel-heading">
                    {{ guia.numeroGuia }}
                  </div>
                  <div class="panel-body panel_info">
                    <table class="table table-striped table-hover tabela_info">
                      <tbody>
                        <tr>
                          <td><strong>Paciente:</strong></td>
                          <td>{{ guia.paciente || '---' }}</td>
                        </tr>
                        <tr>
                          <td><strong>Especialidade:</strong></td>
                          <td>{{ guia.especialidade || '---' }}</td>
                        </tr>
                        <tr>
                          <td><strong>Sessões:</strong></td>
                          <td>{{ guia.quantidade }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="btn-group btn-group-justified" role="group">
                      <div class="btn-group" role="group">
                        <button
                          v-if="!pagamentoFinalizado"
                          data-test-id="button-removerguia-5"
                          type="button"
                          class="btn btn-sm btn-default"
                          title="Remover guia"
                          @click="removerGuia(index)"
                        >
                          <span class="fa fa-trash" /> Remover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import moment from 'moment'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionarGuia from '@/componentes/formulario/BuscarSelecionarGuia'
import { useMenu } from '@/composables/useMenu'
import ProfissionalServico from '@/servicos/ProfissionalServico'

const profissionalServico = new ProfissionalServico()

export default {
  components: {
    BuscarSelecionarGuia,
    BlocoFormularioCadastro,
  },

  setup() {
    useMenu(75)
  },

  data() {
    return {
      filtro: {
        mesAno: moment().format('YYYY-MM'),
        dataInicio: moment().startOf('month').format('DD/MM/YYYY'),
        dataFim: moment().endOf('month').format('DD/MM/YYYY'),
      },
      guiasSelecionadas: [],
      guiaSelecionada: null,
      sessoesSelecionadas: null,
      indicacaoProfissionalId: null,
      carregando: false,
      buscarGuiaKey: 0,
      status: 'Aberto',
    }
  },
  computed: {
    pagamentoFinalizado() {
      return this.status === 'Finalizado'
    },
    pagamentoSubmetido() {
      return this.status === 'Submetido'
    },
    opcoesMesAno() {
      const opcoes = []

      for (let i = 0; i < 24; i++) {
        const data = moment().subtract(i, 'months')
        opcoes.push({
          valor: data.format('YYYY-MM'),
          texto: data.format('MMMM [de] YYYY'),
        })
      }

      return opcoes
    },
  },
  mounted() {
    this.buscarGuias()
  },
  methods: {
    aoSelecionarGuia(guia) {
      this.guiaSelecionada = guia
      this.sessoesSelecionadas = 1
    },

    aoAlterarPeriodo() {
      this.filtro.dataInicio = moment(this.filtro.mesAno, 'YYYY-MM')
        .startOf('month')
        .format('YYYY-MM-DDTHH:mm:ss[Z]')
      this.filtro.dataFim = moment(this.filtro.mesAno, 'YYYY-MM')
        .endOf('month')
        .format('YYYY-MM-DDTHH:mm:ss[Z]')
      this.buscarGuias()
    },

    buscarGuias() {
      profissionalServico
        .recuperarGuiasPagamento()
        .then((result) => {
          const guiasDoMes = result.guias.find(
            (entrada) =>
              entrada.mesReferencia ===
              moment(this.filtro.mesAno, 'YYYY-MM')
                .startOf('month')
                .format('YYYY-MM-DDTHH:mm:ss[Z]')
          )

          if (!guiasDoMes) {
            this.guiasSelecionadas = []
            this.status = 'Aberto'
            this.indicacaoProfissionalId = ''
            return
          }

          this.guiasSelecionadas = guiasDoMes.guias || []
          this.indicacaoProfissionalId = guiasDoMes._id

          if (!!guiasDoMes.finishedAt) {
            this.status = 'Finalizado'
          } else {
            this.status = 'Submetido'
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar guias para pagamento:', error)
        })
    },

    adicionarGuiaSelecionada() {
      if (!this.guiaSelecionada || !this.sessoesSelecionadas) return

      const jaAdicionada = this.guiasSelecionadas.some(
        (g) => g.numeroGuia === this.guiaSelecionada.autorizacao.numeroGuia
      )

      if (jaAdicionada) {
        return
      }

      this.guiasSelecionadas.push({
        _id: this.guiaSelecionada._id,
        numeroGuia: this.guiaSelecionada.autorizacao.numeroGuia,
        paciente: this.guiaSelecionada.beneficiario.nome,
        especialidade: this.guiaSelecionada.especialidade,
        quantidade: this.sessoesSelecionadas,
      })

      this.guiaSelecionada = null
      this.sessoesSelecionadas = null
      this.buscarGuiaKey++
    },

    removerGuia(index) {
      this.guiasSelecionadas.splice(index, 1)
    },

    submeterPagamento() {
      try {
        this.carregando = true

        const dadosPagamento = {
          mesReferencia: moment(this.filtro.mesAno, 'YYYY-MM')
            .startOf('month')
            .format('YYYY-MM-DDTHH:mm:ss[Z]'),
          guias: this.guiasSelecionadas.map((g) => ({
            _id: g._id,
            numeroGuia: g.numeroGuia,
            quantidade: g.quantidade,
          })),
        }

        if (this.indicacaoProfissionalId) {
          profissionalServico.atualizarGuiasPagamento(
            this.indicacaoProfissionalId,
            dadosPagamento
          )
        } else {
          profissionalServico.criarGuiasPagamento(dadosPagamento)
          this.status = 'Submetido'
        }
      } catch (error) {
        console.error('Erro ao submeter pagamento:', error)
      } finally {
        this.carregando = false
      }
    },

    finalizarPagamento() {
      if (!this.indicacaoProfissionalId) {
        console.error('Erro ao finalizar pagamento: pagamento não encontrado')
        return
      }

      try {
        profissionalServico.finalizarGuiasPagamento(
          this.indicacaoProfissionalId
        )

        this.status = 'Finalizado'
      } catch (error) {
        console.error('Erro ao finalizar pagamento:', error)
      }
    },
  },
}
</script>
